import { ChangeDetectionStrategy, Component, inject, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '@auth/auth-service';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';

import { filter } from 'rxjs/operators';

import { LanguageSelector } from './components/language-selector/language-selector';
import { UserDropdown } from './components/user-dropdown/user-dropdown';

@Component({
  selector: 'abc-nav-bar',
  imports: [UserDropdown, RouterLink, RouterLinkActive, LanguageSelector, NgbCollapseModule],
  templateUrl: 'nav-bar.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavBar implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  protected readonly isImpersonating = this.authService.isImpersonating;

  protected readonly isPoweruser = this.authService.isPoweruser;
  protected readonly menuOpen = signal(false);

  ngOnInit() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.closeMenu();
    });
  }

  protected toggleMenu() {
    this.menuOpen.update((open) => !open);
  }

  protected closeMenu() {
    this.menuOpen.set(false);
  }
}
